module.exports = __webpack_public_path__ + "img/nav-georeputation.8f88a983.svg";